import { type UserProfile } from '@/shared/api/user/types';
import { MessageType } from '@/shared/hooks/use-ws/types';
import { AnalyticsService } from '@/shared/service/analytics/analytics-service';

export const gameAnalyticEventNewSessionHandler = (
  value: any,
  sessionId: string,
  profile: UserProfile | undefined
) => {
  const event = {
    type: 'new_session',
    user_properties: {
      ...value?.user_properties,
      session_id: sessionId,
      telegramId: profile?.telegramId,
    },
    event_properties: {
      date: Date.now(),
      name: 'new_session',
    },
  };

  AnalyticsService.send(event, MessageType.GAME_ANALYTICS);
};
